import { ActiveCategoriesSection } from 'src/components/organisms/ActiveCategoriesSection';
import { ActiveCategory } from 'src/components/organisms/ActiveCategoriesSection/ActiveCategoryCard';
import { ActiveCategoriesWrapper } from './CoiFormManagement.styles';
import type { FormManagementSection } from './types';

export interface FormManagementCategorySectionsProps {
  readonly speakUpEnabled: boolean;
  readonly coiEnabled: boolean;
  readonly speakUpCategories: ActiveCategory[];
  readonly coiCategories: ActiveCategory[];
  readonly selectedProductTab: FormManagementSection;
  readonly isLoading: boolean;
  readonly onCreateForm: () => void;
  readonly onCategoryCardClick: (category: ActiveCategory) => void;
}

export function FormManagementCategorySections({
  speakUpEnabled,
  coiEnabled,
  speakUpCategories,
  coiCategories,
  selectedProductTab,
  isLoading,
  onCreateForm,
  onCategoryCardClick,
}: FormManagementCategorySectionsProps) {
  if (!speakUpEnabled && !coiEnabled) return null;

  const bothProductsEnabled = speakUpEnabled && coiEnabled;
  const showSpeakUpCategoriesSection =
    speakUpEnabled &&
    (!bothProductsEnabled || selectedProductTab === 'SPEAK_UP') &&
    speakUpCategories.length > 0;
  const showCoiCategoriesSection =
    coiEnabled && (!bothProductsEnabled || selectedProductTab === 'COI');

  return (
    <ActiveCategoriesWrapper>
      {showSpeakUpCategoriesSection && (
        <ActiveCategoriesSection
          sectionTitle="Published forms"
          sectionTitleVariant="headingH3Bold"
          categories={speakUpCategories}
          isLoading={isLoading}
          onShowAllCategories={
            () => {} /* TODO: implement show-all-categories behavior */
          }
          onCreateForm={onCreateForm}
          onCategoryCardClick={onCategoryCardClick}
          data-testid="speak-up-categories-section"
        />
      )}
      {showCoiCategoriesSection && (
        <ActiveCategoriesSection
          sectionTitle="Published forms"
          sectionTitleVariant="headingH3Bold"
          categories={coiCategories}
          isLoading={isLoading}
          onShowAllCategories={
            () => {} /* TODO: implement show-all-categories behavior */
          }
          onCreateForm={onCreateForm}
          onCategoryCardClick={onCategoryCardClick}
          data-testid="active-categories-section"
        />
      )}
    </ActiveCategoriesWrapper>
  );
}
